import { render, staticRenderFns } from "./ShopCourseItemPreview.vue?vue&type=template&id=176a11cf&"
import script from "./ShopCourseItemPreview.vue?vue&type=script&lang=js&"
export * from "./ShopCourseItemPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports